var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticClass:"btn-success",attrs:{"loading":_vm.loader},on:{"click":_vm.impersonate}},[_vm._v(" Iniciar impersonate ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }